module.exports = __webpack_public_path__ + "img/account.e5e67b1f.svg";